import React from "react"
import { useRoutes } from "../../hooks/useRoutes"

export const withButtonLink = Component => ({ name = "ButtonLink", style = "", size = "", link: originalLink, className = "", wide = false, uppercase }) => {
  const { linkResolver } = useRoutes()
  const link = linkResolver(originalLink)
  Component.displayName = name
  return <Component style={style} link={link} size={size} className={className} wide={wide} uppercase={uppercase} />
}
